import { DescriptionBtnWithPopup } from '../../../../buttons/PromptBtn/DescriptionBtnWithPopup'
import { getLabel } from '../../../../../utils/getLabel'

interface BlockArrayTableHeadProps {
    dataPath: string
    componentSchema: any
    isAddingNewRule: boolean
    setIsAdding: (value: boolean) => void
}

export const BlockArrayTableHead = (props: BlockArrayTableHeadProps) => {
    const { componentSchema } = props
    const names =
        Object.keys(componentSchema).filter((name) => name !== 'element_id') ||
        []

    return (
        <tr
            className="border-bottom bg-body py-4"
            style={{
                color: '#8dabc4',
                fontSize: '.7rem',
                textTransform: 'uppercase',
                position: 'sticky',
                top: 0,
                zIndex: 1000,
            }}
        >
            <td>#</td>
            {names.map((name: string) => (
                <td key={name}>
                    {getLabel(name, componentSchema?.[name]?.name)}
                    {componentSchema?.[name]?.is_required && (
                        <span className="app-color-red text-lowercase">*</span>
                    )}{' '}
                    {componentSchema[name]?.description && (
                        <DescriptionBtnWithPopup
                            type="small"
                            header={getLabel(
                                name,
                                componentSchema?.[name]?.name
                            )}
                            description={componentSchema[name]?.description}
                            className="mt-1"
                        />
                    )}
                </td>
            ))}
            <td>Actions</td>
        </tr>
    )
}
